import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core';
import StyledCheckbox from '../../../utils/componentutils/StyledCheckbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { selectOptionsBasedOnShortCuts } from '../../forms/tradeplans/tradingPlanFormComponents/FieldComponents/OptionChains';
import FormLabel from '@material-ui/core/FormLabel';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { setUpOptions } from '../../forms/tradeplans/tradingPlanFormComponents/hooks/setup/SetupHooks';
//import WebSocketConnection, {ws} from "../../../znotusedcurrently/websocket/WebSocket.jsx2";
import TradeHistoryDisplays from './TradeHistoryDisplays';
import { sendWebsocketMessage } from '../../../App';
import { Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    margin: theme.spacing(3),
  },
  input: { fontSize: 10 },
}));
const boxProps = {
  bgcolor: 'background.paper',
  m: 1,
  borderColor: 'text.primary',
};
export default function TradeHistoryForm({}) {
  const classes = useStyles();
  const [liveTrades, setLiveTrades] = useState(true);
  const [simTrades, setSimTrades] = useState(true);

  const [userSubmitSymbol, setUserSubmitSymbol] = useState(false);
  const [symbol, setSymbol] = useState('');
  const [userSubmitSetup, setUserSubmitSetup] = useState(false);
  const [setup, setSetup] = useState('');

  const [userDateType, setUserDateType] = useState('all');

  const [startMonth, setStartMonth] = useState();
  const [startDay, setStartDay] = useState();
  const [startYear, setStartYear] = useState();

  const [endMonth, setEndMonth] = useState();
  const [endDay, setEndDay] = useState();
  const [endYear, setEndYear] = useState();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    setStartDate(startYear + '-' + startMonth + '-' + startDay);
  }, [startMonth, startDay, startYear]);

  useEffect(() => {
    setEndDate(endYear + '-' + endMonth + '-' + endDay);
  }, [endMonth, endDay, endYear]);
  let dateTxtBoxHeight = 60;
  let dateTxtBoxWidth = 60;
  const submit = () => {
    const msg = {
      messageType: 'requestTradeHistory',
      allSymbols: !userSubmitSymbol,
      symbol: symbol,
      allSetups: !userSubmitSetup,
      setup: setup,
      userDateType: userDateType,
      startDate: startDate,
      endDate: endDate,
      allowLiveTrades: liveTrades,
      allowSimTrades: simTrades,
    };
    //let msg = JSON.stringify(msgObject);
    //console.log(msg)
    sendWebsocketMessage(msg);
  };

  const handleDownload = () => {
    const msg = {
      messageType: 'requestTradeHistoryDownload',
      allSymbols: !userSubmitSymbol,
      symbol: symbol,
      allSetups: !userSubmitSetup,
      setup: setup,
      userDateType: userDateType,
      startDate: startDate,
      endDate: endDate,
      allowLiveTrades: liveTrades,
      allowSimTrades: simTrades,
    };

    const backendHost = (window.config && window.config.REACT_APP_REDIRECT
      ? window.config.REACT_APP_REDIRECT : 'http://localhost:8080/');
    fetch(`${backendHost}tradeHistoryDownload`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(msg),
    })
      .then((response) => {
        if (response.ok) {
          return response.blob();
        } else {
          throw new Error('Download failed');
        }
      })
      .then((blob) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'closed_positions.csv';
        downloadLink.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleExport = () => {
    const msg = {
      messageType: 'requestTradeHistoryExport',
      allSymbols: !userSubmitSymbol,
      symbol: symbol,
      allSetups: !userSubmitSetup,
      setup: setup,
      userDateType: userDateType,
      startDate: startDate,
      endDate: endDate,
      allowLiveTrades: liveTrades,
      allowSimTrades: simTrades,
    };

    const backendHost = (window.config && window.config.REACT_APP_REDIRECT
      ? window.config.REACT_APP_REDIRECT : 'http://localhost:8080/');
    fetch(`${backendHost}tradeHistoryExport`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(msg),
    })
      .then((response) => {
        if (response.ok) {
          return response.blob();
        } else {
          throw new Error('Export failed');
        }
      })
      .then((blob) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'tradeHistoryDump.zip';
        downloadLink.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography>
          <u>
            <b>TRADE HISTORY</b>
          </u>
        </Typography>
      </Grid>
      {/*  <Grid item xs={2}>
            <div className={classes.root}>
                <FormControl component={"fieldset"} className={classes.formControl}>
                    <FormLabel>
                        Symbol:
                    </FormLabel>
                </FormControl>
                <FormControlLabel
                    checked={!userSubmitSymbol}
                    control={
                        <StyledCheckbox
                            color="primary" //checked={isAlreadyWorkOrder}
                            onChange={ev => {
                                setUserSubmitSymbol(!ev.target.checked)
                            }}
                        />
                    }
                    label={
                        <Typography style={{fontSize: 12, color: "blue"}}>
                            all
                        </Typography>
                    }
                    labelPlacement={"start"}
                    //labelPlacement="start"
                />
                &nbsp;&nbsp;
                {userSubmitSymbol ?
                    <TextField variant={"outlined"} size={"small"} onChange={ev => setSymbol(ev.target.value)}/> : null}
            </div>
        </Grid>*/}
      <Grid item container xs={4} alignItems="baseline">
        <Box
          //display="flex"
          //  flexDirection="column"
          alignItems="stretch"
          border={1}
          width={'100%'}
          //overflow="scroll"
          {...{
            bgcolor: 'background.paper',
            m: 1,
            // height: "400px",
            borderColor: 'text.primary',
          }}
        >
          <Grid item xs={12}>
            <div className={classes.root}>
              <FormControl
                component={'fieldset'}
                className={classes.formControl}
              >
                <FormLabel>Setup:</FormLabel>
              </FormControl>
              <FormControlLabel
                checked={!userSubmitSetup}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setUserSubmitSetup(!ev.target.checked);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    all
                  </Typography>
                }
                labelPlacement={'start'}
                //labelPlacement="start"
              />
              &nbsp;&nbsp;
              {userSubmitSetup ? (
                <TextField
                  variant={'outlined'}
                  size={'small'}
                  select
                  onChange={(ev) => setSetup(ev.target.value)}
                  // SelectProps={{fontSize: 1}}
                  InputProps={{ classes: { input: classes.input } }}
                  inputProps={{ style: { fontSize: 10 } }}
                >
                  {Object.values(setUpOptions).map((option) => (
                    <MenuItem
                      key={option.key}
                      value={option.key}
                      style={{ fontSize: 10 }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              ) : null}
            </div>
          </Grid>
          <Grid item xs={12} container>
            <div className={classes.root}>
              <FormLabel>Account:</FormLabel>
              <FormControlLabel
                checked={simTrades}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setSimTrades(ev.target.checked);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    simulated
                  </Typography>
                }
                labelPlacement={'start'}
                //labelPlacement="start"
              />
              <FormControlLabel
                checked={liveTrades}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setLiveTrades(ev.target.checked);
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    live
                  </Typography>
                }
                labelPlacement={'start'}
                //labelPlacement="start"
              />
            </div>
          </Grid>
          <Grid item xs={12} container>
            <div className={classes.root}>
              {/*<Grid item xs={12}>*/}
              <FormControl
                component={'fieldset'}
                className={classes.formControl}
              >
                <FormLabel>Date:</FormLabel>
              </FormControl>
              <FormControlLabel
                checked={userDateType === 'all'}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setUserDateType('all');
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    all
                  </Typography>
                }
                labelPlacement={'end'}
                //labelPlacement="start"
              />
              <FormControlLabel
                checked={userDateType === 'today'}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setUserDateType('today');
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    today
                  </Typography>
                }
                labelPlacement={'end'}
                //labelPlacement="start"
              />
              <FormControlLabel
                checked={userDateType === 'yesterday'}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setUserDateType('yesterday');
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    yesterday
                  </Typography>
                }
                labelPlacement={'start'}
                //labelPlacement="start"
              />
              <FormControlLabel
                checked={userDateType === 'manual'}
                control={
                  <StyledCheckbox
                    color="primary" //checked={isAlreadyWorkOrder}
                    onChange={(ev) => {
                      setUserDateType('manual');
                    }}
                  />
                }
                label={
                  <Typography style={{ fontSize: 12, color: 'blue' }}>
                    choose_date
                  </Typography>
                }
                labelPlacement={'start'}
                //labelPlacement="start"
              />
              {/*
                    </Grid>*/}
            </div>
            {userDateType === 'manual' ? (
              <Grid item xs={12} container>
                <Grid item xs={6}>
                  <FormLabel>Start:</FormLabel>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'m'}
                    InputProps={{ classes: { input: classes.input } }}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    onChange={(ev) => setStartMonth(ev.target.value)}
                  >
                    {months.map((m) => (
                      <MenuItem key={m} value={m} style={{ fontSize: 10 }}>
                        {m}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'d'}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={(ev) => setStartDay(ev.target.value)}
                  >
                    {days.map((d) => (
                      <MenuItem key={d} value={d} style={{ fontSize: 10 }}>
                        {d}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'y'}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={(ev) => setStartYear(ev.target.value)}
                  >
                    {years.map((y) => (
                      <MenuItem key={y} value={y} style={{ fontSize: 10 }}>
                        {y}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={6}>
                  <FormLabel>Finish:</FormLabel>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'m'}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={(ev) => setEndMonth(ev.target.value)}
                  >
                    {months.map((m) => (
                      <MenuItem key={m} value={m} style={{ fontSize: 10 }}>
                        {m}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'d'}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={(ev) => setEndDay(ev.target.value)}
                  >
                    {days.map((d) => (
                      <MenuItem key={d} value={d} style={{ fontSize: 10 }}>
                        {d}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    variant={'outlined'}
                    size={'small'}
                    select
                    label={'y'}
                    style={{ height: dateTxtBoxHeight, width: dateTxtBoxWidth }}
                    InputProps={{ classes: { input: classes.input } }}
                    onChange={(ev) => setEndYear(ev.target.value)}
                  >
                    {years.map((y) => (
                      <MenuItem key={y} value={y} style={{ fontSize: 10 }}>
                        {y}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={1}>
            <input
              //onKeyPress="return event.keyCode!=13"
              type="submit"
              className="btn btn-primary m-2 addTradePlan"
              value={'SUBMIT'}
              onClick={submit}
            />
{/*
            <input
              //onKeyPress="return event.keyCode!=13"
              type="submit"
              className="btn btn-primary m-2 addTradePlan"
              startIcon={<GetAppIcon />}
              value={'DOWNLOAD'}
              onClick={handleDownload}
            />
*/}
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              startIcon={<GetAppIcon />}
              onClick={handleDownload}
            >
              Download
            </Button>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              startIcon={<GetAppIcon />}
              onClick={handleExport}
            >
              Export
            </Button>
          </Grid>
        </Box>
      </Grid>
      {/*<Grid item container xs={12}>*/}
      <TradeHistoryDisplays />
      {/*</Grid>*/}
    </Grid>
  );
}

const months = Array.from({ length: 12 }, (_, i) => i + 1);
const days = Array.from({ length: 31 }, (_, i) => i + 1);
const currentYear = new Date().getFullYear();
const years = Array.from(
  { length: currentYear - 2019 },
  (_, index) => 2020 + index
);
